
import { uid } from 'uid'

export default {
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    nums: {
      type: Number,
      default: 4,
    },
    modelValue: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      current: -1,
    }
  },
  computed: {
    value: {
      get() {
        return this.modelValue
      },
      set(v) {
        this.$emit('update:modelValue', v)
      },
    },
    id() {
      return 'ct-phone-code' + uid()
    },
  },
  methods: {
    active(index) {
      this.current = index
    },
    splice(index) {
      if (this.value.length > index) {
        return this.value.slice(index, index + 1)
      }
      return ''
    },
    blur() {
      this.current = -1
    },
    input($event) {
      if ($event.target.value.length > this.nums) {
        this.value = $event.target.value.slice(0, this.nums)
      } else if ($event.target.value > this.value) {
        this.current = this.value.length + 1
      } else {
        this.current = this.value.length - 1
      }
    },
    enter() {
      this.$emit('enter', true)
    },
  },
}
